import {
    get,
    post
} from '@/network/request.js';

export const list = p => get('article/index', p)
export const detail = p => get('article/detail/' + p, {})
export const ticket = p => post('general/jsTicket', p)